export const APP_ROUTES = [
  { value: "/archive", label: "归档" },
  { value: "/", label: "最新" },
  { value: "/rss.xml", label: "rss" },
];
